// import React, { useState, useEffect } from 'react';
// import { motion, AnimatePresence } from 'motion/react';
// import { X, Mail, Smartphone, Lock, User, Eye, EyeOff, Check, Loader2 } from 'lucide-react';
// import { LoginStepOne } from './auth/LoginStepOne';
// import { PasswordLogin } from './auth/PasswordLogin';
// import { OtpLogin } from './auth/OtpLogin';
// import { SignupForm } from './auth/SignupForm';

// interface AuthModalProps {
//   isOpen: boolean;
//   onClose: () => void;
//   onLoginSuccess?: () => void;
// }

// type AuthMode = 'login' | 'signup';
// type LoginStep = 'identifier' | 'password' | 'otp';

// export function AuthModal({ isOpen, onClose, onLoginSuccess }: AuthModalProps) {
//   const [authMode, setAuthMode] = useState<AuthMode>('login');
//   const [loginStep, setLoginStep] = useState<LoginStep>('identifier');
//   const [identifier, setIdentifier] = useState('');
//   const [identifierType, setIdentifierType] = useState<'email' | 'mobile' | null>(null);

//   // Reset state when modal closes
//   useEffect(() => {
//     if (!isOpen) {
//       setTimeout(() => {
//         setAuthMode('login');
//         setLoginStep('identifier');
//         setIdentifier('');
//         setIdentifierType(null);
//       }, 300);
//     }
//   }, [isOpen]);

//   const handleIdentifierSubmit = (value: string, type: 'email' | 'mobile') => {
//     setIdentifier(value);
//     setIdentifierType(type);
//     setLoginStep(type === 'email' ? 'password' : 'otp');
//   };

//   const handleBackToIdentifier = () => {
//     setLoginStep('identifier');
//     setIdentifierType(null);
//   };

//   const handleSwitchMode = () => {
//     setAuthMode(authMode === 'login' ? 'signup' : 'login');
//     setLoginStep('identifier');
//     setIdentifier('');
//     setIdentifierType(null);
//   };

//   const handleSuccess = () => {
//     onClose();
//     if (onLoginSuccess) {
//       onLoginSuccess();
//     }
//   };

//   return (
//     <AnimatePresence>
//       {isOpen && (
//         <>
//           {/* Backdrop */}
//           <motion.div
//             initial={{ opacity: 0 }}
//             animate={{ opacity: 1 }}
//             exit={{ opacity: 0 }}
//             transition={{ duration: 0.3 }}
//             className="fixed inset-0 bg-black/60 backdrop-blur-sm z-50"
//             onClick={onClose}
//           />

//           {/* Modal */}
//           <div className="fixed inset-0 z-50 flex items-center justify-center p-4 pointer-events-none">
//             <motion.div
//               initial={{ opacity: 0, scale: 0.95, y: 20 }}
//               animate={{ opacity: 1, scale: 1, y: 0 }}
//               exit={{ opacity: 0, scale: 0.95, y: 20 }}
//               transition={{ duration: 0.3, ease: 'easeOut' }}
//               className="w-full max-w-md pointer-events-auto"
//               onClick={(e) => e.stopPropagation()}
//             >
//               {/* Glass Card */}
//               <div className="relative bg-card/95 backdrop-blur-xl border border-border rounded-3xl shadow-2xl overflow-hidden">
//                 {/* Gradient Glow */}
//                 <div className="absolute -top-40 -right-40 w-80 h-80 bg-primary/20 rounded-full blur-3xl" />
//                 <div className="absolute -bottom-40 -left-40 w-80 h-80 bg-accent/20 rounded-full blur-3xl" />

//                 {/* Close Button */}
//                 <button
//                   onClick={onClose}
//                   className="absolute top-4 right-4 z-10 p-2 rounded-full hover:bg-muted transition-colors"
//                 >
//                   <X className="w-5 h-5 text-muted-foreground" />
//                 </button>

//                 {/* Content */}
//                 <div className="relative p-8 sm:p-10">
//                   {/* Logo/Title */}
//                   <div className="text-center mb-8">
//                     <h2 className="text-3xl font-bold text-foreground mb-2">
//                       {authMode === 'login' ? 'Welcome Back' : 'Create Account'}
//                     </h2>
//                     <p className="text-muted-foreground">
//                       {authMode === 'login' 
//                         ? 'Sign in to your NFC Design Studio account' 
//                         : 'Join NFC Design Studio today'}
//                     </p>
//                   </div>

//                   {/* Auth Forms */}
//                   <AnimatePresence mode="wait">
//                     {authMode === 'login' ? (
//                       <motion.div
//                         key="login"
//                         initial={{ opacity: 0, x: -20 }}
//                         animate={{ opacity: 1, x: 0 }}
//                         exit={{ opacity: 0, x: 20 }}
//                         transition={{ duration: 0.3 }}
//                       >
//                         {loginStep === 'identifier' && (
//                           <LoginStepOne onSubmit={handleIdentifierSubmit} />
//                         )}
//                         {loginStep === 'password' && (
//                           <PasswordLogin
//                             email={identifier}
//                             onBack={handleBackToIdentifier}
//                             onSuccess={handleSuccess}
//                           />
//                         )}
//                         {loginStep === 'otp' && (
//                           <OtpLogin
//                             mobile={identifier}
//                             onBack={handleBackToIdentifier}
//                             onSuccess={handleSuccess}
//                           />
//                         )}
//                       </motion.div>
//                     ) : (
//                       <motion.div
//                         key="signup"
//                         initial={{ opacity: 0, x: 20 }}
//                         animate={{ opacity: 1, x: 0 }}
//                         exit={{ opacity: 0, x: -20 }}
//                         transition={{ duration: 0.3 }}
//                       >
//                         <SignupForm onSuccess={handleSuccess} />
//                       </motion.div>
//                     )}
//                   </AnimatePresence>

//                   {/* Toggle Auth Mode */}
//                   <div className="mt-6 text-center">
//                     <p className="text-sm text-muted-foreground">
//                       {authMode === 'login' 
//                         ? "Don't have an account? " 
//                         : 'Already have an account? '}
//                       <button
//                         onClick={handleSwitchMode}
//                         className="text-primary font-semibold hover:underline"
//                       >
//                         {authMode === 'login' ? 'Sign Up' : 'Login'}
//                       </button>
//                     </p>
//                   </div>
//                 </div>
//               </div>
//             </motion.div>
//           </div>
//         </>
//       )}
//     </AnimatePresence>
//   );
// }









import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { X } from "lucide-react";
import LoginStepOne from "./Auth/LoginStepOne";
import OtpLogin from "./Auth/OtpLogin";
import SignupForm from "./Auth/SignupForm";
import PasswordLogin from "./Auth/PasswordLogin";
import ForgotPasswordForm from "./Auth/ForgotPassword";

export const AuthModal = ({ isOpen, onClose, onLoginSuccess }) => {
  const [authMode, setAuthMode] = useState("login"); // login | signup
  const [loginStep, setLoginStep] = useState("identifier"); // identifier | otp
  const [identifier, setIdentifier] = useState("");
  const [identifierType, setIdentifierType] = useState(null); // email | mobile | null
  const [forgotPassword, setForgotPassword] = useState(false);

  // Reset state when modal closes
  useEffect(() => {
    if (!isOpen) {
      setTimeout(() => {
        setAuthMode("login");
        setLoginStep("identifier");
        setIdentifier("");
        setIdentifierType(null);
      }, 300);
    }
  }, [isOpen]);

  const handleIdentifierSubmit = (value, type) => {
    setIdentifier(value);
    setIdentifierType(type);
    setLoginStep(type === "email" ? "password" : "otp");
  };

  const handleBackToIdentifier = () => {
    setLoginStep("identifier");
    setIdentifierType(null);
  };

  const handleSwitchMode = () => {
    setAuthMode(authMode === "login" ? "signup" : "login");
    setLoginStep("identifier");
    setIdentifier("");
    setIdentifierType(null);
  };

  const handleSuccess = () => {
    onClose();
    if (onLoginSuccess) onLoginSuccess();
  };

  return (
    <AnimatePresence>
      {isOpen && (
        <>
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.3 }}
            onClick={onClose}
            style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.6)", backdropFilter: "blur(4px)", zIndex: 50, }}
          />

          {/* Modal Wrapper */}
          <div style={{ position: "fixed", inset: 0, zIndex: 51, display: "flex", justifyContent: "center", padding: "16px", pointerEvents: "none", overflowY: "auto", WebkitOverflowScrolling: "touch", }}>
            <motion.div
              initial={{ opacity: 0, scale: 0.95, y: 20 }}
              animate={{ opacity: 1, scale: 1, y: 0 }}
              exit={{ opacity: 0, scale: 0.95, y: 20 }}
              transition={{ duration: 0.3, ease: "easeOut" }}
              onClick={(e) => e.stopPropagation()}
              style={{ width: "100%", maxWidth: "420px", pointerEvents: "auto", display: "flex", flexDirection: "column", maxHeight: "100vh", }}
            >
              {/* Card */}
              <div style={{ position: "relative", background: "#ffffff", borderRadius: "24px", boxShadow: "0 25px 60px rgba(0,0,0,0.25)", overflow: "hidden", display: "flex", flexDirection: "column", }}>
                <button onClick={onClose} style={{ position: "absolute", top: "16px", right: "16px", border: "none", background: "transparent", cursor: "pointer", }}><X size={20} /></button>
                <div style={{ padding: "32px", overflowY: "auto", }}>
                  <div style={{ textAlign: "center", marginBottom: "24px" }}>
                    <h2 style={{ fontSize: "26px", marginBottom: "8px" }}>
                      {authMode === "login" ? "Welcome Back" : "Create Account"}
                    </h2>
                    <p style={{ color: "#6b7280", fontSize: "14px" }}>
                      {authMode === "login"
                        ? "Sign in to your NFC Design Studio account"
                        : "Join NFC Design Studio today"}
                    </p>
                  </div>
                  <AnimatePresence mode="wait">
                    {forgotPassword ? (
                      <motion.div
                        key="forgot"
                        initial={{ opacity: 0, x: 20 }}
                        animate={{ opacity: 1, x: 0 }}
                        exit={{ opacity: 0, x: -20 }}
                        transition={{ duration: 0.3 }}
                      >
                        <ForgotPasswordForm onBack={() => setForgotPassword(false)} />
                      </motion.div>
                    ) : authMode === "login" ? (
                      <motion.div
                        key="login"
                        initial={{ opacity: 0, x: -20 }}
                        animate={{ opacity: 1, x: 0 }}
                        exit={{ opacity: 0, x: 20 }}
                        transition={{ duration: 0.3 }}
                      >
                        {loginStep === "identifier" && (
                          <LoginStepOne
                            onSubmit={handleIdentifierSubmit}
                            onForgotPassword={() => setForgotPassword(true)}
                          />
                        )}
                        {loginStep === "password" && (
                          <PasswordLogin
                            email={identifier}
                            onBack={handleBackToIdentifier}
                            onSuccess={handleSuccess}
                            onForgotPassword={() => setForgotPassword(true)}
                          />
                        )}
                        {loginStep === "otp" && (
                          <OtpLogin
                            mobile={identifier}
                            onBack={handleBackToIdentifier}
                            onSuccess={handleSuccess}
                          />
                        )}
                      </motion.div>
                    ) : (
                      <motion.div
                        key="signup"
                        initial={{ opacity: 0, x: 20 }}
                        animate={{ opacity: 1, x: 0 }}
                        exit={{ opacity: 0, x: -20 }}
                        transition={{ duration: 0.3 }}
                      >
                        <SignupForm onSuccess={handleSuccess} />
                      </motion.div>
                    )}
                  </AnimatePresence>

                  {/* Switch Mode */}
                  <div style={{ marginTop: "20px", textAlign: "center" }}>
                    <p style={{ fontSize: "14px", color: "#6b7280" }}>
                      {authMode === "login"
                        ? "Don't have an account? "
                        : "Already have an account? "}
                      <button onClick={handleSwitchMode} style={{ background: "none", border: "none", color: "#6366f1", fontWeight: "600", cursor: "pointer", }}>
                        {authMode === "login" ? "Sign Up" : "Login"}
                      </button>
                    </p>
                  </div>
                </div>
              </div>
            </motion.div>
          </div>
        </>
      )}
    </AnimatePresence>
  );
};
